import { useState, useRef} from "react";
import Loader from "react-loader-spinner";
import { HiEyeOff, HiEye } from "react-icons/hi";
import {
	Box,
	Button,
	Alert,
	AlertIcon,
	InputGroup,
	InputRightElement,
	IconButton,
	chakra,
	FormControl,
	FormLabel,
	Input,
	Flex,
	Stack,
	Img,
	Text,
	VStack,
	Collapse,
	SimpleGrid,
	useDisclosure,
} from "@chakra-ui/react";
import { toAbsoluteUrl } from "../../utils/helper";
import { useAuth } from "../../plugins/CookieAuthPlugin";
import { APP_VERSION } from "../../constants/app";
import { login } from "../../utils/apiClient/auth";
export default function Login() {
	const { loginAuth, refetchUser } = useAuth();
	const { isOpen, onToggle } = useDisclosure();
	const [error, setError] = useState("");
	const [captcha, /* setCaptcha */] = useState("");
	const recaptchaRef = useRef();
	const [logLoading, setLogLoading] = useState(false);

	return (
		<SimpleGrid pos="relative" columns={{ md: 2, sm: 1 }} h="100vh">
			<Box d={{ base: "none", md: "block" }} bgRepeat="no-repeat" bgSize="cover" bgPosition="center" bgImage={toAbsoluteUrl("/assets/illustrator.png")}/>
			<VStack bgRepeat="no-repeat" overflow="hidden" bgColor="brand.100" pb={{ base: "4rem", md: "6rem" }} justify="center" spacing="5rem">
				<Img h={{ base: "6rem", md: "8rem" }} src={toAbsoluteUrl("/assets/LOGO.png")} alt="K Cement Logo"/>
				<Box zIndex="banner" w={{ base: "80%", md: "60%" }}>
					<chakra.form
						onSubmit={async (e) => {
							e.preventDefault();
							const formData = new FormData(e.target);
							const formProps = Object.fromEntries(formData);
							setLogLoading(true);
							let res = await login({ deviceId: 12, deviceName: 12, username: formProps.username, password: formProps.password, siteKey: captcha });
							try {
								if (res?.header?.errorCode === "401" || res?.header?.statusCode === 401) {
									recaptchaRef.current.reset();
									setError(res?.header.errorText);
								}
								if (res.header.result) {
									await loginAuth({ token: res?.body?.accessToken });
									res && refetchUser();
								}
								if (!res.body.status) {
									recaptchaRef.current.reset();
									setError(res.body.message);
								}
							} catch (err) {
								setError(err.header?.errorCode === "401" ? "Something went wrong please try again" : "Incorrect username or password");
								setLogLoading(false);
							}
						}}
					>
						<Stack spacing="4">
							<FormControl id="username">
								<FormLabel color="gray.600" fontWeight="normal">
									Username
								</FormLabel>
								<Input bg="white" name="username" placeholder="Enter Username" autoComplete="text" required />
							</FormControl>
							<FormControl id="password">
								<FormLabel color="gray.600" fontWeight="normal">
									Password
								</FormLabel>
								<InputGroup>
									<InputRightElement>
										<IconButton
											tabIndex="-1"
											bg="transparent !important"
											variant="ghost"
											aria-label={isOpen ? "Mask password" : "Reveal password"}
											icon={isOpen ? <HiEye /> : <HiEyeOff />}
											onClick={onToggle}
											_focus={{ outline: "none" }}
											colorScheme="brand"
										/>
									</InputRightElement>
									<Input bg="white" name="password" type={isOpen ? "text" : "password"} autoComplete="current-password" placeholder="Enter Password" required />
								</InputGroup>
							</FormControl>
							{logLoading ? "" : (<Collapse in={error} animateOpacity>
								<Alert status="error">
									<AlertIcon />
									{error}
								</Alert>
							</Collapse>)}
							

							<Button type="submit" isLoading={logLoading} spinner={<Loader type="ThreeDots" color="#fff" height={40} width={40} />} colorScheme="brand" size="md">
								LOGIN
							</Button>
						</Stack>
					</chakra.form>
				</Box>

				<Flex opacity="0.9" pos="fixed" bottom="5" fontSize="small" fontWeight="bold">
					Powered​ by&nbsp;<Text color="red.600">UDAYA TECHNOLOGY Co., Ltd.</Text>
					&nbsp;
					<Text bg={"transparent"} color="transparent" _hover={{ color: "gray.500" }}>
						v{APP_VERSION}
					</Text>
				</Flex>
			</VStack>
		</SimpleGrid>
	);
}
